import "./style.scss";

import book from "./img/book.svg";
import people from "./img/people.svg";
import { observeElementOnScreen } from "../../helpers/utils";
import { useEffect, useRef } from "react";

const Rise = () => {
    const riseRef = useRef();

    useEffect(() => {
        const observer = observeElementOnScreen(riseRef.current, -100);
        return () => observer?.disconnect();
    }, []);

    return (
        <div className="rise" ref={riseRef}>
            <div className="rise__text-block">
                <span className="rise__title">Растём вместе с&nbsp;вашими достижениями</span>
                <span className="rise__subtitle">Сделаем красивые материалы, проверим, что&nbsp;нравится&nbsp;людям, и всё подстроим под вас</span>
                <a href="https://ris.promo/" className="rise__link" target="_blank">
                    Ознакомиться с продуктом
                </a>
            </div>
            <div className="rise__stats">
                <div className="rise__gifts">
                    <div className="rise__gifts-item">
                        <span className="rise__stats-text">100+ </span>
                        <span className="rise__stats-sub">подарков в&nbsp;20&nbsp;разных&nbsp;категориях</span>
                    </div>
                    <img src={book} className="rise__img" />
                </div>
                <div className="rise__traffic">
                    <span className="rise__stats-text rise__stats-text_white">23 000 000 млн</span>
                    <span className="rise__stats-sub rise__stats-sub_white">Пользователей ежемесячный&nbsp;трафик</span>
                </div>
                <div className="rise__personal">
                    <img src={people} className="rise__img rise__img_people" />
                    <div className="rise__aim">
                        <span>Наша основная цель - </span>
                        <span className="rise__aim-bold">высокая персонализация</span>
                    </div>
                </div>
            </div>
            <a href="https://ris.promo/" className="rise__link rise__link_mobile" target="_blank">
                Ознакомиться с продуктом
            </a>
        </div>
    );
};

export default Rise;
